import { createGlobalStyle } from 'styled-components';

export const Tokens = createGlobalStyle`
:root {
  /* Typography Tokens */
  --font: "Inter", "system-ui", sans-serif;

  @supports (font-variation-settings: normal) {
    --font: "Inter var experimental", "system-ui", sans-serif;
  }

  --font-header: var(--font);
  --font-mono: Menlo, Courier, monospace;

  --font-size-xs: ${12 / 16}rem;
  --font-size-sm: ${14 / 16}rem;
  --font-size-md: 14px;
  --font-size-lg: ${16 / 16}rem;
  --font-size-xl: ${18 / 16}rem;
  --font-size-2xl: ${32 / 16}rem;
  --font-size-3xl: ${40 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    --font-size-xs: ${12 / 16}rem;
    --font-size-sm: ${14 / 16}rem;
    --font-size-md: 16px;
    --font-size-lg: ${18 / 16}rem;
    --font-size-xl: ${24 / 16}rem;
    --font-size-2xl: ${32 / 16}rem;
    --font-size-3xl: ${50 / 16}rem;
  }

  --text-xs: 400 var(--font-size-xs)/150% var(--font);
  --text-sm: 400 var(--font-size-sm)/130% var(--font);
  --text-md: 400 var(--font-size-md)/120% var(--font);
  --text-lg: 400 var(--font-size-lg)/130% var(--font);
  --text-xl: 400 var(--font-size-xl)/110% var(--font);
  --text-2xl: 400 var(--font-size-2xl)/110% var(--font);
  --text-3xl: 400 var(--font-size-3xl)/110% var(--font);

  --h1: 800 var(--font-size-3xl)/105% var(--font);
  --h2: 800 var(--font-size-2xl)/105% var(--font);
  --h3: 800 var(--font-size-xl)/110% var(--font);
  --h4: 800 var(--font-size-lg)/110% var(--font);
  --h5: 700 var(--font-size-lg)/110% var(--font);
  --h6: 700 var(--font-size-md)/110% var(--font);


  /* Color Tokens */
  --color-green: #7ce7d6;
  --color-blue: #04b2e1;
  --color-red: #ff282d;
  --color-black: #070506;
  --color-white: #fbfcff;
  --color-grey: #f0f0f0;
  --color-grey-dark: #373d4c;
  --color-blue-dark: #434e58;
  --color-blue-grey: #75949f;
  --color-grey-darker #1C2930;


  --color-text: var(--color-black);
  --color-text-muted: var(--color-grey-dark);
  --color-dark-text: var(--color-white);
  --color-dark-text-muted: var(--color-grey);

  --color-text-live: var(--color-blue);
  --color-link: #0071d9;
  --color-btn-green: #58FCE3;
  --color-btn-red: var(--color-red);
  --color-btn-green-hover: var(--color-scale-20); // #A5FFFF btn colors, lightened 30%
  --color-btn-red-hover: #FF757A; // btn colors, lightened 30%

  --color-focus: var(--color-link);

  --color-gradient-start: var(--color-green);
  --color-gradient-end: var(--color-blue);

  --color-background-dark: var(--color-grey-darker);
  --color-background-light: var(--color-white);

  --color-asset-video:  var(--color-blue-dark);
  --color-asset-book: var(--color-blue-grey);
  --color-asset-podcast: #3FBBC2;
  --color-asset-article: var(--color-blue);

  --color-scale-10: #ecfcfa;
  --color-scale-20: #9efff0;
  --color-scale-30: var(--color-green);
  --color-scale-40: var(--color-blue-grey);
  --color-scale-50: var(--color-blue);
  --color-scale-60: #00bb9e;
  --color-scale-70: #0090ae;
  --color-scale-80: #3c616f;
  --color-scale-90: #006d5d;
}`;
